import HeroVideoCard from './HeroVideoCard';
import { mediaUrl } from '../../lib/api';
import { DEFAULT_HERO_VIDEO_SRC, useSettings } from '../../store/settingsStore';

interface HeroPromoVideoCardProps {
  variant?: 'mobile' | 'desktop';
}

export default function HeroPromoVideoCard({ variant = 'desktop' }: HeroPromoVideoCardProps) {
  const { heroVideoType, heroVideoSrc, heroYoutubeUrl } = useSettings();
  const className = variant === 'mobile'
    ? 'w-fit rounded-3xl border border-glass-line/15 bg-gradient-to-b from-raised/70 via-surface/80 to-canvas/85 p-2 mx-3 min-h-0 flex flex-col'
    : 'w-fit rounded-3xl border border-glass-line/15 bg-gradient-to-b from-raised/70 via-surface/80 to-canvas/85 p-3 mx-3 my-2 h-full min-h-0 flex flex-col max-h-[60vh]';
  const youtubeVideoId = heroVideoType === 'youtube' ? youtubeId(heroYoutubeUrl) : '';
  const videoSrc = heroVideoType === 'youtube' ? '' : resolveVideoSrc(heroVideoSrc || DEFAULT_HERO_VIDEO_SRC);

  return (
    <div className={className}>
      <HeroVideoCard
        videoSrc={videoSrc}
        poster="/videos/TCpromo-poster.webp"
        youtubeVideoId={youtubeVideoId}
        aspectClassName="aspect-square"
        className="h-auto max-h-[18rem] w-full max-w-[18rem] border border-glass-line/15 shadow-lg shadow-brand/10 lg:h-full lg:max-h-full lg:w-auto lg:max-w-full"
      />
    </div>
  );
}

function resolveVideoSrc(value: string) {
  const clean = value.trim();
  if (!clean) return DEFAULT_HERO_VIDEO_SRC;
  if (clean.startsWith('http') || clean.startsWith('/')) return clean;
  if (clean.startsWith('videos/')) return `/${clean}`;
  return mediaUrl(clean);
}

function youtubeId(value: string) {
  try {
    const url = new URL(value);
    if (url.hostname.includes('youtu.be')) return url.pathname.replace(/^\//, '');
    if (url.pathname.startsWith('/shorts/')) return url.pathname.split('/')[2] || '';
    if (url.pathname.startsWith('/embed/')) return url.pathname.split('/')[2] || '';
    return url.searchParams.get('v') || '';
  } catch {
    return value;
  }
}
